import axios from 'axios'
import { camelizeKeys, decamelizeKeys } from 'humps'

import { BASE_URL } from 'constants/misc'
import { getCheckinAuthHeader } from 'utils/checkinAuth'
import { CHECKIN_USER_DATA } from 'utils/loginStorage'

export interface TruckbookApiResponse<T> {
  status: string
  data: T
  message: string | null
}

export const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// リクエストインターセプター: 認証ヘッダー付与 + decamelizeKeys
apiClient.interceptors.request.use((config) => {
  const authHeaders = getCheckinAuthHeader(CHECKIN_USER_DATA)
  Object.entries(authHeaders).forEach(([key, value]) => {
    config.headers.set(key, value)
  })
  if (config.params) {
    config.params = decamelizeKeys(config.params)
  }
  if (config.data) {
    config.data = decamelizeKeys(config.data)
  }
  return config
})

// レスポンスインターセプター: camelizeKeys
apiClient.interceptors.response.use((response) => {
  response.data = camelizeKeys(response.data)
  return response
})
